import { Box, Button, Grid, Typography } from "@mui/material";

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HowToOrder from "../components/home/HowToOrder";
import HowToVid from "../components/misc/HowToVid";
import BreadcrumbsTemplate from "../components/misc/BreadcrumbsTemplate";
import { Link } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { mergeManagedContent } from "../hooks/mergeManagedContent";
import { useLangPath } from "../hooks/langAlias";
import { colors, eyebrowSx, fonts, radii, shadows } from "../theme/designTokens";

export default function HowToOrderScreen({ setPolicyOpen, setPolicyName }) {
  const [langId, setLangId] = useState("");
  const [contentSettings, setContentSettings] = useState([]);
  const { managedContentSettings } = useSelector(
    (state) => state.managedContentSettings
  );
  const { activeLangFront } = useSelector((state) => state.miscFront);
  const { langs } = useSelector((state) => state.misc);
  const lp = useLangPath();

  useEffect(() => {
    if (activeLangFront) setLangId(activeLangFront._id);
  }, [activeLangFront]);

  useEffect(() => {
    if (
      managedContentSettings &&
      managedContentSettings.length > 0 &&
      langId !== ""
    ) {
      const M = mergeManagedContent(managedContentSettings, langId, langs);
      if (M) setContentSettings(M);
    }
  }, [langId, managedContentSettings]);

  const hasVideo =
    contentSettings.howToOrderVideos &&
    contentSettings.howToOrderVideos.length > 0;

  // Functions
  const handlePolicy = (policy) => {
    setPolicyOpen(true);
    setPolicyName(policy);
  };
  return (
    <Box sx={{ bgcolor: colors.paper }}>
      <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2, sm: 3 } }}>
        <Box sx={{ pt: 2.5 }}>
          <BreadcrumbsTemplate b3="How To Order" sx={{ mx: 0 }} />
        </Box>

        <Box sx={{ textAlign: "center", maxWidth: 640, mx: "auto", pt: 3, pb: 5 }}>
          <Box sx={eyebrowSx}>Getting Started</Box>
          <Typography
            sx={{
              fontFamily: fonts.display,
              fontWeight: 800,
              fontSize: { xs: "1.8rem", sm: "2.2rem" },
              color: colors.ink,
              mt: 2,
            }}
          >
            How to Order From Us
          </Typography>
          <Typography sx={{ fontSize: 15, color: colors.ink2, lineHeight: 1.65, mt: 1.5 }}>
            A simple, secure process from search to delivery.
          </Typography>
        </Box>

        {hasVideo && (
          <Box
            sx={{
              borderRadius: radii.lg,
              boxShadow: shadows.card,
              border: `1px solid ${colors.line}`,
              bgcolor: colors.ink,
              p: { xs: 1.5, sm: 2.5 },
              mb: 5,
              display: "flex",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            <HowToVid contentSettings={contentSettings} />
          </Box>
        )}

        <Grid container spacing={3} sx={{ pb: 6 }}>
          <Grid item xs={12} md={7}>
            <Box
              sx={{
                borderRadius: radii.lg,
                boxShadow: shadows.card,
                border: `1px solid ${colors.line}`,
                bgcolor: colors.white,
                p: { xs: 2.5, sm: 3.5 },
              }}
            >
              <HowToOrder />
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                borderRadius: radii.lg,
                bgcolor: colors.primaryDark,
                p: { xs: 2.5, sm: 3.5 },
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
                height: "100%",
              }}
            >
              <Typography sx={{ fontFamily: fonts.display, fontWeight: 700, fontSize: 15, color: "#fff", mb: 0.5 }}>
                Ready When You Are
              </Typography>
              <Link to={lp("/our-medicines")} style={{ textDecoration: "none" }}>
                <Button
                  variant="contained"
                  fullWidth
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    bgcolor: colors.accent,
                    borderRadius: radii.md,
                    textTransform: "none",
                    fontWeight: 700,
                    boxShadow: "none",
                    "&:hover": { bgcolor: "#C94F21", boxShadow: "none" },
                  }}
                >
                  Order Now
                </Button>
              </Link>
              <Link to={lp("/contact-us")} style={{ textDecoration: "none" }}>
                <Button
                  variant="outlined"
                  fullWidth
                  sx={{
                    borderColor: "rgba(255,255,255,0.5)",
                    color: "#fff",
                    borderRadius: radii.md,
                    textTransform: "none",
                    fontWeight: 700,
                    "&:hover": { borderColor: "#fff", bgcolor: "rgba(255,255,255,0.08)" },
                  }}
                >
                  Contact Us
                </Button>
              </Link>
              <Box sx={{ display: "flex", gap: 3, mt: 1 }}>
                <Typography
                  onClick={() => handlePolicy("terms-and-conditions")}
                  sx={{ fontSize: 13, fontWeight: 600, color: "rgba(255,255,255,0.85)", cursor: "pointer", "&:hover": { color: "#fff" } }}
                >
                  Terms &amp; Conditions
                </Typography>
                <Typography
                  onClick={() => handlePolicy("shipping-policy")}
                  sx={{ fontSize: 13, fontWeight: 600, color: "rgba(255,255,255,0.85)", cursor: "pointer", "&:hover": { color: "#fff" } }}
                >
                  Shipping Policy
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
